import React from 'react';
import {IonRouterLink} from '@ionic/react';

import TabBar from './TabBar';
import Tab from './Tab';

const Help = () => (
  <TabBar showLogout={false}>
    <IonRouterLink href="https://help.raise.me" target="_blank" rel="noopener noreferrer">
      <Tab>Visit Help Desk</Tab>
    </IonRouterLink>
    <IonRouterLink href="mailto:support@raise.me">
      <Tab>Contact Support</Tab>
    </IonRouterLink>
  </TabBar>
);

export default Help;
